/* Enable only after the hosted app and Shopify app proxy pass an end-to-end test. */
(()=>{
 const config=window.ExpressluvSearchInsights;
 if(!config?.enabled||!config.endpoint?.startsWith('/apps/'))return;
 const key='elv-search-insights-pending';
 const send=x=>fetch(config.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(x),keepalive:true}).then(r=>r.ok).catch(()=>false);
 document.addEventListener('submit',e=>{
  const form=e.target.closest?.('[data-elv-gift-search]');if(!form)return;
  const term=form.querySelector('[data-elv-keyword]')?.value.trim();
  const select=form.querySelector('[data-elv-country]');const country=select?.selectedOptions[0]?.textContent.trim();
  if(!select?.value||!term||!form.checkValidity()||term.length>200)return;
  const event={id:crypto.randomUUID(),term,country};
  try{sessionStorage.setItem(key,JSON.stringify({...event,expires:Date.now()+300000}));}catch{}
  void send(event);
 },true);
 let busy=false;
 async function finished(){
  if(busy)return;
  let event;try{event=JSON.parse(sessionStorage.getItem(key)||'null');}catch{return;}
  if(!event)return;
  if(event.expires<Date.now()){sessionStorage.removeItem(key);return;}
  const section=document.querySelector('[data-elv-results]');if(!section||section.hasAttribute('data-elv-pending')||section.dataset.country!==event.country)return;
  const q=new URLSearchParams(location.search);if((q.get('gift_query')||q.get('q'))!==event.term)return;
  const count=Number(section.dataset.count);if(!Number.isSafeInteger(count)||count<0)return;
  busy=true;const ok=await send({id:event.id,term:event.term,country:event.country,count});
  if(ok){sessionStorage.removeItem(key);observer.disconnect();}busy=false;
 }
 const observer=new MutationObserver(()=>void finished());observer.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['data-elv-pending','data-count']});
 void finished();
})();
